import React from 'react'

export default function CameraVideoIcon({ className = 'text-white', size = 42 }) {
  return (
    <svg className={className} width={size} viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M40.5357 2.5C40.1786 2.32143 39.8214 2.32143 39.6429 2.5L33.3929 7.32143V5.17857C33.3929 2.32143 31.0714 0 28.2143 0H5.17857C2.32143 0 0 2.32143 0 5.17857V21.25C0 24.1071 2.32143 26.4286 5.17857 26.4286H28.2143C31.0714 26.4286 33.3929 24.1071 33.3929 21.25V19.1071L39.6429 23.9286C39.8214 24.1071 40.1786 24.1071 40.5357 23.9286C40.8929 23.75 41.0714 23.5714 41.0714 23.2143V3.21429C41.0714 2.85714 40.8929 2.67857 40.5357 2.5Z" fill="white"/>
    </svg>

  )
}
